require("./bootstrap");
import Vue from "vue";

import { App, plugin } from "@inertiajs/inertia-vue";
import { InertiaProgress } from "@inertiajs/progress";

import PortalVue from "portal-vue";
import VModal from "vue-js-modal";
import ElementUI from "element-ui";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import VueWaypoint from "vue-waypoint";
import { get } from "lodash";
import { Toast, Popup } from "vant";
import VueScrollTo from "vue-scrollto";

import "dayjs/locale/zh-cn";
import "./filter";
import "vant/lib/toast/style";

InertiaProgress.init({ color: "#d8232a" });

dayjs.locale("zh-cn");
dayjs.extend(LocalizedFormat);
dayjs.extend(relativeTime);

Vue.config.productionTip = false;
Vue.prototype.dayjs = dayjs;

Vue.component("Icon", () => import("@/Shared/Icon"));

Vue.mixin({ methods: { route } });
Vue.use(plugin);
Vue.use(PortalVue);
Vue.use(ElementUI);
Vue.use(VueWaypoint);
Vue.use(VueScrollTo);

Vue.use(Toast);
Toast.setDefaultOptions({ position: "bottom" });

Vue.use(VModal, {
    dynamicDefaults: {
        adaptive: true,
        maxWidth: 900,
        height: "auto",
        classes: "base-modal",
        shiftY: 0,
        transition: "modaltrans"
    }
});

Vue.mixin({
    methods: {
        route: window.route,
        trans(key) {
            return get(this.$page.props.trans, key, key);
        },
        role(roleItem = "") {
            try {
                return this.$page.props.self_roles.includes(roleItem);
            } catch (e) {
                return false;
            }
        },
        can(permission = "") {
            try {
                return this.$page.props.self_permissions.includes(permission);
            } catch (e) {
                return false;
            }
        }
    }
});

const el = document.getElementById("app");

new Vue({
    render: h =>
        h(App, {
            props: {
                initialPage: JSON.parse(el.dataset.page),
                resolveComponent: name =>
                    import(`./Pages/${name}`).then(module => module.default)
            }
        })
}).$mount(el);
